import { render, staticRenderFns } from "./AddAssign.vue?vue&type=template&id=15629886&scoped=true&"
import script from "./AddAssign.vue?vue&type=script&lang=js&"
export * from "./AddAssign.vue?vue&type=script&lang=js&"
import style0 from "./AddAssign.vue?vue&type=style&index=0&id=15629886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15629886",
  null
  
)

export default component.exports